import { useEffect, useState } from "react";
import { IoMdArrowUp } from "react-icons/io";
import "./BackToTopButton.css";
import { scrollToTop } from "../../../utils/scroll";
import { MOBILE_MENU_EVENT } from "../../layout/Header/Header";

const BackToTopButton = () => {
  const [show, setShow] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleMenuChange = (e) => {
      setIsMenuOpen(Boolean(e.detail?.open));
    };

    window.addEventListener(MOBILE_MENU_EVENT, handleMenuChange);

    return () => {
      window.removeEventListener(MOBILE_MENU_EVENT, handleMenuChange);
    };
  }, []);

  if (!show || isMenuOpen) {
    return null;
  }

  return (
    <div className="backtop">
      <button
        onClick={scrollToTop}
        className="btn backtop-btn"
        aria-label="Voltar ao topo"
      >
        <IoMdArrowUp className="backtop-icon" />

        <span className="tooltip">
          Voltar ao topo
          <span className="tooltip-arrow" />
        </span>
      </button>
    </div>
  );
};

export default BackToTopButton;